export type DeliveryMethodType = keyof typeof DeliveryMethod;

export interface TripNotification {
  notificationId: number;
  deliveryMethod: DeliveryMethodType;
  state: string;
  recipient: string;
  sentTime?: string;
  sender?: string;
  senderAlias?: string;
  renderedSubject?: string;
  renderedBody?: string;
}

export const DeliveryMethod = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};